import React, { Component, createRef } from 'react';
import {
    Container,
    Row,
    Col,
    FormControl,
    ListGroup,
    FormCheck,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';

class JobSampleManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percentageStrings: {},
        };
        this.jobStartURLInputRef = createRef();
        this.handlePartialCrawlChange = this.handlePartialCrawlChange.bind(this);
    }

    componentDidMount() {
        this.initializeConfigurations();
    }

    initializeConfigurations = () => {
        const percentageStrings = {};
        if (this.props.extractionItem) {
            // Initialize all jobs with their existing percentage or default to "100"
            this.props.extractionItem.job_definitions.forEach((jobDefinition) => {
                percentageStrings[jobDefinition.id] = jobDefinition.sample_percent?.toString() || "100";
            }); 
        }
        this.setState({ percentageStrings });
    };

    handlePartialCrawlChange = (e) => {
        const extraction = { ...this.props.extractionItem };
        extraction.partial_crawl = e.target.checked;
        this.props.stateManagementService.updateExtraction(extraction, true);
    };

    handleSliderChange = (jobDefinitionId, e) => {
        this.props.extractionItem.job_definitions.forEach((jobDefinition) => {
            if (jobDefinition.id == jobDefinitionId) {
                const newPercentage = e.target.value / 10;
                const newPercentageStrings = { ...this.state.percentageStrings };
                newPercentageStrings[jobDefinitionId] = newPercentage.toString();
                this.setState({
                    percentageStrings: newPercentageStrings
                });
                this.props.stateManagementService.updateJobDefinition({ ...jobDefinition, sample_percent: newPercentage });
            }
        });
    };

    handleTextChange = (jobDefinitionId, e) => {
        let value = 0;
        let addDecimalPoint = false;
        // If the value has more than one decimal point, return
        if (e.target.value.split('.').length > 2) return;
        
        // If the text input ends with a decimal point, set the value to the value without the decimal point
        if (e.target.value.endsWith('.')) {
            addDecimalPoint = true;
            value = parseFloat(e.target.value.slice(0, -1));
        } else {
            value = parseFloat(e.target.value);
        }
        // If the value is a valid number, set the state
        if (!isNaN(value) && value >= 0.0 && value <= 100.0) {
            value = Math.floor(value * 10) / 10
            this.props.extractionItem.job_definitions.forEach((jobDefinition) => {
                if (jobDefinition.id == jobDefinitionId) {
                    this.setState({ 
                        percentageStrings: {
                            ...this.state.percentageStrings,
                            [jobDefinitionId]: value + (addDecimalPoint ? '.' : '')
                        }
                    });
                    this.props.stateManagementService.updateJobDefinition({ ...jobDefinition, sample_percent: value });
                }
            });
        }
    };

    render() {

        const sliderStyle = {
            accentColor: '#18bc9c'
        };

        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="button-tooltip">Your script may spawn many jobs for a full crawl. Use this to sample a subset for a partial crawl</Tooltip>}
                        >
                            <FormCheck
                                type="checkbox"
                                label="Partial Crawl"
                                checked={this.props.extractionItem?.partial_crawl}
                                onChange={this.handlePartialCrawlChange}
                                style={{ paddingLeft: "10px", paddingRight: "10px" }}
                            />
                        </OverlayTrigger>
                    </Col>
                </Row>
                {this.props.extractionItem?.partial_crawl && (
                    <Container className="mt-3">
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <ListGroup>
                                {this.props.extractionItem.job_definitions.map((jobDefinition) => (
                                    <ListGroup.Item key={jobDefinition.id} className="d-flex align-items-center">
                                        <div style={{ width: '50%' }}>{jobDefinition.job_reference}</div>
                                        <div style={{ width: '35%' }}>
                                            <FormControl
                                                type="range"
                                                value={jobDefinition.sample_percent ? jobDefinition.sample_percent * 10 : 1000}
                                                onChange={(e) => this.handleSliderChange(jobDefinition.id, e)}
                                                min={0}
                                                max={1000}
                                                style={sliderStyle}
                                            />
                                        </div>
                                        <div style={{ width: '15%' }} className="d-flex align-items-center">
                                            <FormControl
                                                type="text"
                                                value={this.state.percentageStrings[jobDefinition.id] || "100"}
                                                onChange={(e) => this.handleTextChange(jobDefinition.id, e)}
                                                className="text-center"
                                                style={{ width: '80%' }}
                                            />
                                            <div className="text-center" style={{ width: '20%' }}>%</div>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    </Container>
                )}
            </Container>
        );
    }
}

export default JobSampleManager;
